// 改变 console 方法，添加时间和级别
// for (const logkey of ['debug', 'log', 'info', 'warn', 'error']) {
//   if (!console[logkey]) continue;

//   if (!console[`_custom263_${logkey}`]) {
//     console[`_custom263_${logkey}`] = console[logkey];
//     console[logkey] = function() {
//       const date = new Date();

//       if (arguments[0] && typeof arguments[0] === 'string' && /(socket.io|engine.io|%c)/.test(arguments[0])) { // socket.io 打印的日志
//         console[`_custom263_${logkey}`](...arguments, logkey.toLocaleUpperCase(), `${date.toLocaleString()}.${date.getMilliseconds()}`);
//         return;
//       }
//       console[`_custom263_${logkey}`](`${date.toLocaleString()}.${date.getMilliseconds()}`, logkey.toLocaleUpperCase(), ...arguments);
//     }
//   }
// }

import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
Vue.config.productionTip = false;
import i18n from "@/utils/i18n";
import "element-ui/lib/theme-chalk/index.css";
import "vue-263-player/lib/vue-263-player.css";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import VueVirtualScroller from "vue-virtual-scroller";
import Vue263player from "vue-263-player";
import "./assets/styles/common.scss";
import "./assets/styles/theme.scss";
import Directives from "./directives";
import particles from "particles.js";
import preview from "vue-photo-preview";
import Icon from "vue-svg-icon/Icon.vue";
import "vue-photo-preview/dist/skin.css";
import enLocale from "element-ui/lib/locale/lang/en";
import cnLocale from "element-ui/lib/locale/lang/zh-CN";
import twLocale from "element-ui/lib/locale/lang/zh-TW";
import locale from "element-ui/lib/locale";
import { WebMonitor, MitoVue } from "web_monitoring";

const logger = new WebMonitor({
  appName: "cloud_webcast",
  version: "CLA",
  jsError: true, //是否捕捉js错误和资源加载错误,默认true
  eventCatch: true, //js错误是否捕捉最后一次点击事件,默认true
  promiseError: true, //是否捕捉promise错误,默认true
  performanceNavigation: true, //是否捕捉页面性能,默认true
  getFps: true, //是否捕捉fps,默认true
  refreshOrLeave: true, //是否捕捉beforeunload事件,默认true
  consoleCatch: true, //是否捕捉console,默认true，默认只捕捉error,可配置consoleTypeList
  consoleTypeList: ["warn","error"], //需要捕捉的consoleType ['error','warn','info','log',...]
  xhrCatch: true, //是否捕捉xhr请求
  ignoreXhr: [], //ignoreXhr忽略捕捉接口的数组
});
Vue.prototype.logger = logger;
window.logger = logger;

Vue.use(MitoVue, {
  appName: "cloud_webcast",
});
Vue.use(particles);
Vue.use(preview);
import { TableColumn,Button, Dialog, Select, Option, Checkbox, Input, Scrollbar, Message, MessageBox, Switch, Loading, Popover, Form, FormItem, Upload, Divider, Radio, RadioGroup, CheckboxGroup, Tooltip, Popconfirm, Pagination,Table,Image } from "element-ui";
Vue.use(Vue263player);
Vue.use(Directives);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Loading.directive);
Vue.component("icon", Icon);
Vue.use(Select);
Vue.use(Option);
Vue.use(Checkbox);
Vue.use(Input);
Vue.use(Scrollbar);
Vue.use(VueVirtualScroller);
Vue.use(Switch);
Vue.use(Popover);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Upload);
Vue.use(Divider);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(CheckboxGroup);
Vue.use(Tooltip);
Vue.use(Popconfirm);
Vue.use(Pagination);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Image);
Vue.prototype.$msgbox  = MessageBox;
Vue.prototype.$message = Message;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$loading = Loading;

if (i18n.locale == "zh-CN") {
  locale.use(cnLocale);
} else if (i18n.locale == "zh-TW") {
  locale.use(twLocale);
} else {
  locale.use(enLocale);
}

new Vue({
  router: router(),
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
